import React, {ReactNode, StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './styles/main.scss';
import {Provider} from 'react-redux';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router-dom';
import {PostHogProvider} from '@posthog/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {store} from './store/store';
import {initAppErrorLogger} from './utils/sentry/sentry';
import {initPostHog, isPostHogEnabled, posthog} from './utils/posthog/posthog';

initAppErrorLogger();
initPostHog('incase-player');

const queryClient: QueryClient = new QueryClient();

const root = createRoot(document.getElementById('root') as HTMLElement);

function withPostHog(children: ReactNode): ReactNode {
    if (!isPostHogEnabled()) {
        return children;
    }

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

root.render(
    withPostHog(
        <StrictMode>
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </QueryClientProvider>
            </Provider>
        </StrictMode>
    )
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
